import { styled, css } from 'styled-components';
import { InputWrapper } from '@template/components/Input/styles.ts';

export const CartDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 250px;
  padding: 12px;
  gap: 8px;
`;

export const CartFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 19px;
  font-weight: 700;
  line-height: 78%;
  color: ${({ theme }) => theme.colors.default[900]};
  &:first-of-type {
    border-top: 1px solid ${({ theme }) => theme.colors.default[200]};
    padding-top: 24px;
  }
`;

export const TotalLabel = styled.p``;

export const TotalValue = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    color: ${({ theme }) => theme.colors.default[500]};
    margin-left: 4px;
  }
`;

export const StartContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const FooterButton = styled.div`
  align-self: flex-end;
`;

export const CartItemsWrapper = styled.div<{ $advanced?: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: auto;

  ${({ $advanced }) =>
    $advanced
      ? css``
      : css`
          max-height: 300px;
        `}
`;

export const CartItemContainer = styled.div`
  color: ${({ theme }) => theme.colors.default[400]};
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  font-size: 14px;
  gap: 12px;
  position: relative;
  align-items: center;
`;

export const InlineContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const ExtrasContainer = styled.div`
  width: 100%;
  gap: 24px;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  ${({ theme }) => theme.breakpoints.sm.query} {
    display: flex;
    flex-direction: column;
  }
`;

export const CartItemLabel = styled.p`
  font-weight: 600;
  display: flex;
  height: fit-content;
  align-items: center;
  gap: 2px;

  & svg {
    color: ${({ theme }) => theme.colors.default[300]};
  }

  & > button {
    &:hover {
      & svg {
        color: revert;
      }
    }
  }

  > span {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const CartItemPrice = styled.div`
  font-weight: 900;
`;

export const ItemType = styled.div`
  justify-self: flex-start;
  margin-right: auto;
  font-weight: 700;
  font-size: 19px;
  color: ${({ theme }) => theme.colors.default[600]};
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  & svg {
    color: ${({ theme }) => theme.colors.default[600]};
  }

  & > button {
    &:hover {
      & svg {
        color: revert;
      }
    }
  }
`;

export const CartItemWrapper = styled.div<{ $advanced?: boolean }>`
  overflow-x: clip;
  overflow-y: visible;
  ${({ $advanced, theme }) =>
    $advanced &&
    css`
      &:not(:last-of-type) {
        border-bottom: 1px solid ${theme.colors.default[100]};
      }

      ${CartItemPrice} {
        margin-left: auto;
      }

      ${InlineContainer} {
        flex-direction: column;
        gap: 2px;
        align-items: flex-start;
      }

      ${ItemType} {
        ${theme.breakpoints.sm.query} {
          align-items: flex-start;
          flex-wrap: wrap;

          ${CartItemPrice} {
            flex-basis: 100%;
          }
        }
        ${theme.breakpoints.xs.query} {
          ${InputWrapper} {
            flex-basis: 100%;
            justify-content: flex-start;
            > * {
              width: fit-content;
              margin-left: revert !important;
            }
          }
        }
      }
    `}
`;

export const Help = styled.span`
  width: 16px;
  height: 16px;

  > svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.default[400]};
  }
`;
